// geoThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import hostURL from "../../Common/constants";
import secureLocalStorage from "react-secure-storage";

// STATES
export const fetchGeoStates = createAsyncThunk(
  "geo/fetchGeoStates",
  async (_, { rejectWithValue }) => {
    try {
      const authToken = secureLocalStorage.getItem("token"); // or however you're storing the token

      const response = await fetch(`${hostURL}/api/states`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authToken,
        },
      });

      const data = await response.json();
      return data.map((item) => ({ value: item.scode, label: item.sname }));
    } catch (err) {
      console.error("❌ fetchGeoStates failed:", err);
      return rejectWithValue(err.message);
    }
  }
);

// COUNTIES
export const fetchGeoCountiesByState = createAsyncThunk(
  "geo/fetchGeoCountiesByState",
  async (selectedState, { rejectWithValue }) => {
    try {
      const authToken = secureLocalStorage.getItem("token");
      const response = await fetch(
        `${hostURL}/api/counties?state=${selectedState}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: authToken,
          },
        }
      );
      const json = await response.json();
      const list = json.map((item) => ({
        value: item.cname,
        label: item.cname,
      }));
      return { list, raw: json };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
